var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66797 13.3346V15.668C6.66797 16.6014 6.66797 17.0681 6.84962 17.4246C7.00941 17.7382 7.26438 17.9932 7.57798 18.153C7.9345 18.3346 8.40121 18.3346 9.33464 18.3346H15.668C16.6014 18.3346 17.0681 18.3346 17.4246 18.153C17.7382 17.9932 17.9932 17.7382 18.153 17.4246C18.3346 17.0681 18.3346 16.6014 18.3346 15.668V9.33464C18.3346 8.40121 18.3346 7.9345 18.153 7.57798C17.9932 7.26438 17.7382 7.00941 17.4246 6.84962C17.0681 6.66797 16.6014 6.66797 15.668 6.66797H13.3346M4.33464 13.3346H10.668C11.6014 13.3346 12.0681 13.3346 12.4246 13.153C12.7382 12.9932 12.9932 12.7382 13.153 12.4246C13.3346 12.0681 13.3346 11.6014 13.3346 10.668V4.33464C13.3346 3.40121 13.3346 2.9345 13.153 2.57798C12.9932 2.26438 12.7382 2.00941 12.4246 1.84962C12.0681 1.66797 11.6014 1.66797 10.668 1.66797H4.33464C3.40121 1.66797 2.9345 1.66797 2.57798 1.84962C2.26438 2.00941 2.00941 2.26438 1.84962 2.57798C1.66797 2.9345 1.66797 3.40121 1.66797 4.33464V10.668C1.66797 11.6014 1.66797 12.0681 1.84962 12.4246C2.00941 12.7382 2.26438 12.9932 2.57798 13.153C2.9345 13.3346 3.40121 13.3346 4.33464 13.3346Z",
    stroke: "#0F426B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4512_10605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.2d2d24a1ae890f0b22c747f4e6e5436c.svg";
export { ForwardRef as ReactComponent };